export enum CmsPage {
    HomePage = 'HomePage',
    GymPage = 'GymPage',
    RegionPage = 'RegionPage',
}

export interface PromoSnackBarOptions {
    isSticky: boolean;
    promoStartDate: string | null;
}

export type AvailableGym = {
    branchId: string;
    gymName: string;
    gymPageURL: string;
    isAvailableOnGymList?: boolean;
};

export enum CmsSpacingSizes {
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
}
